import { FunctionComponent } from "react";
import { Button } from "@chakra-ui/react";
import styles from "./ImFucked.module.css";
const ImFucked: FunctionComponent = () => {
  return (
    <div className={styles.imFucked}>
      <div className={styles.top}>
        <div className={styles.sectionelementorSection}>
          <i className={styles.heyThereFreeContainer}>
            {`Hey there! Free trials are available for Standard and Essentials plans. `}
            <a
              className={styles.startForFreeToday}
              href="https://app.contentiify.com/login"
              target="_blank"
            >
              <span className={styles.startForFree}>Start for free today.</span>
            </a>
          </i>
        </div>
      </div>
      <div className={styles.imFuckedInner}>
        <div className={styles.frameParent}>
          <div className={styles.frameWrapper}>
            <div className={styles.contentiifyParent}>
              <img
                className={styles.contentiifyIcon}
                alt=""
                src="/contentiify.svg"
              />
              <div className={styles.catgoryWrapper}>
                <div className={styles.catgory}>
                  <div className={styles.products}>
                    <div className={styles.features}>Features</div>
                    <img className={styles.icon} alt="" src="/1.svg" />
                  </div>
                  <div className={styles.platform}>
                    <div className={styles.features}>Resources</div>
                    <img className={styles.icon} alt="" src="/11.svg" />
                  </div>
                  <div className={styles.pricing}>
                    <div className={styles.features}>Pricing</div>
                  </div>
                  <div className={styles.pricing}>
                    <div className={styles.features}>Request demo</div>
                  </div>
                </div>
              </div>
              <div className={styles.login}>
                <div className={styles.vectorParent}>
                  <img className={styles.vectorIcon} alt="" src="/vector.svg" />
                  <div className={styles.english}>English</div>
                  <img className={styles.icon2} alt="" src="/2.svg" />
                </div>
                <div className={styles.login1}>Login</div>
              </div>
            </div>
          </div>
          <div className={styles.buttonactButtonWrapper}>
            <Button
              className={styles.buttonactButton}
              variant="solid"
              w="129px"
              colorScheme="tealvinh2"
            >
              Try it free
            </Button>
          </div>
          <img
            className={styles.vectorStrokeIcon}
            alt=""
            src="/vector-stroke1.svg"
          />
        </div>
      </div>
      <div className={styles.body}>
        <div className={styles.frameGroup}>
          <div className={styles.frameContainer}>
            <div className={styles.groupWrapper}>
              <div className={styles.empowerYourBusinessWithVirParent}>
                <b className={styles.empowerYourBusinessContainer}>
                  <span className={styles.empowerYourBusinessContainer1}>
                    <p className={styles.empowerYourBusiness}>
                      Empower your business
                    </p>
                    <p className={styles.empowerYourBusiness}>
                      with viral contents
                    </p>
                  </span>
                </b>
                <img
                  className={styles.groupChild}
                  alt=""
                  src="/vector-121.svg"
                />
              </div>
            </div>
            <div className={styles.frameDiv}>
              <div className={styles.theSocialMediaContentMarkWrapper}>
                <div className={styles.theSocialMedia}>
                  The social media content, marketing campaign management, and
                  even spying your competitors to get insights with low-cost.
                </div>
              </div>
              <div className={styles.buttonactButton1}>
                <div className={styles.getViral}>Get viral</div>
              </div>
              <div className={styles.tryItFreeNoCreditCardReWrapper}>
                <div className={styles.tryItFree}>
                  Try it free. No credit card required. Instant setup.
                </div>
              </div>
            </div>
          </div>
          <div className={styles.imageCrop1Wrapper}>
            <img
              className={styles.imageCrop1Icon}
              alt=""
              src="/image-crop-111@2x.png"
            />
          </div>
        </div>
        <img className={styles.bodyChild} alt="" src="/frame-1336@2x.png" />
      </div>
      <div className={styles.bodyTrending}>
        <div className={styles.the1ContentIntelligenceParent}>
          <b className={styles.the1ContentContainer}>
            <span>The</span>
            <span className={styles.contentIntelligence}>
              {" "}
              #1 Content Intelligence
            </span>
            <span>{` & Content Generator Platform`}</span>
          </b>
          <div className={styles.contentify251Parent}>
            <img
              className={styles.contentify251}
              alt=""
              src="/contentify--2-5-1@2x.png"
            />
            <div className={styles.groupContainer}>
              <div className={styles.rectangleParent}>
                <div className={styles.groupItem} />
                <b className={styles.spy100cContents}>Spy 100°C contents!</b>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.bodyAbtesting}>
        <div className={styles.frameParent1}>
          <div className={styles.spyYourCompetitorSAudiencWrapper}>
            <b className={styles.spyYourCompetitorContainer}>
              <p className={styles.empowerYourBusiness}>
                Spy your competitor ‘s audience
              </p>
              <p
                className={styles.forInsights}
              >{`for insights & A/B testing`}</p>
            </b>
          </div>
          <div className={styles.groupFrame}>
            <div className={styles.contentify11Parent}>
              <img
                className={styles.contentify11}
                alt=""
                src="/contentify--1-1@2x.png"
              />
              <div className={styles.rectangleGroup}>
                <div className={styles.groupInner} />
                <b className={styles.audienceAnalyticsForContainer}>
                  <span className={styles.empowerYourBusinessContainer1}>
                    <p className={styles.empowerYourBusiness}>
                      Audience analytics
                    </p>
                    <p className={styles.empowerYourBusiness}> for any post!</p>
                  </span>
                </b>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.bodyHottopic}>
        <div className={styles.frameParent2}>
          <div className={styles.tailorContentsBasedOnHotTWrapper}>
            <b className={styles.tailorContentsBasedContainer}>
              <p
                className={styles.empowerYourBusiness}
              >{`Tailor contents based on `}</p>
              <p className={styles.empowerYourBusiness}>
                <span className={styles.contentIntelligence}>Hot topic</span>
                <span className={styles.span}>{` `}</span>
                <span>for Organic traffics</span>
              </p>
            </b>
          </div>
          <div className={styles.contentify22Parent}>
            <img
              className={styles.contentify22}
              alt=""
              src="/contentify--2-2@2x.png"
            />
            <div className={styles.rectangleContainer}>
              <div className={styles.rectangleDiv} />
              <b className={styles.autoGenerateVideos}>
                Auto generate videos, images, wrtiten contents
              </b>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.bodySchedule}>
        <div className={styles.frameParent2}>
          <div className={styles.scheduleYourContentsAheadWrapper}>
            <b className={styles.scheduleYourContentsContainer}>
              <span>Schedule</span>
              <span className={styles.yourContents}>{` your contents `}</span>
              <span>ahead</span>
            </b>
          </div>
          <div className={styles.contentify42Parent}>
            <img
              className={styles.contentify42}
              alt=""
              src="/contentify--4-2@2x.png"
            />
            <div className={styles.groupDiv}>
              <div className={styles.groupChild1} />
              <b
                className={styles.getThingsPlanned}
              >{`Get things planned & tracked`}</b>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.body1}>
        <div className={styles.stage}>
          <div className={styles.aiPoweredForSeamlessMarketParent}>
            <b className={styles.aiPoweredForContainer}>
              <span className={styles.empowerYourBusinessContainer1}>
                <span>AI powered</span>
                <span className={styles.forSeamlessMarketing}>
                  {" "}
                  for seamless Marketing experiences
                </span>
              </span>
            </b>
            <div className={styles.divelementorWidgetWrapParent}>
              <div className={styles.divelementorWidgetWrap}>
                <div className={styles.pseudo} />
                <b className={styles.reach}>Reach</b>
                <div className={styles.span1}>
                  <div className={styles.targetToThose}>
                    Target to those with the same interest discover ideal
                    prospects and expand your audience.
                  </div>
                </div>
                <div className={styles.ulelementorIconListItems}>
                  <div className={styles.hashtagAnalytics}>
                    Hashtag analytics
                  </div>
                  <div className={styles.audienceDemographicsAnalytic}>
                    Audience demographics analytics
                  </div>
                  <div className={styles.socialIntelligenceFacebook}>
                    Social intelligence (Facebook, Tiktok, Instagram, Youtube)
                  </div>
                  <div className={styles.timeSeriesAnalytics}>
                    Time-series analytics
                  </div>
                </div>
              </div>
              <div className={styles.divelementorWidgetWrap}>
                <div className={styles.pseudo1} />
                <b className={styles.nurture}>Nurture</b>
                <div className={styles.p}>
                  <div className={styles.growYourRelationshipContainer}>
                    <span className={styles.empowerYourBusinessContainer1}>
                      <p className={styles.empowerYourBusiness}>
                        Grow your relationship with
                      </p>
                      <p className={styles.empowerYourBusiness}>
                        your audience by providing
                      </p>
                      <p className={styles.empowerYourBusiness}>
                        tailored approaches.
                      </p>
                    </span>
                  </div>
                </div>
                <div className={styles.ulelementorIconListItems1}>
                  <div className={styles.aiSupportedContents}>
                    AI supported contents
                  </div>
                  <div
                    className={styles.suggestedMessaging}
                  >{`Suggested messaging & hashtags`}</div>
                  <div
                    className={styles.performanceMonitoring}
                  >{`Performance monitoring & predicting`}</div>
                  <div
                    className={styles.contentScheduling}
                  >{`Content scheduling & Campaign management`}</div>
                </div>
              </div>
              <div className={styles.divelementorWidgetWrap}>
                <div className={styles.pseudo} />
                <b className={styles.convert}>Convert</b>
                <div className={styles.p}>
                  <div className={styles.provideIndividualAudienceContainer}>
                    <span className={styles.empowerYourBusinessContainer1}>
                      <p className={styles.empowerYourBusiness}>
                        Provide individual audience
                      </p>
                      <p className={styles.empowerYourBusiness}>
                        members with well-timed
                      </p>
                      <p className={styles.empowerYourBusiness}>
                        calls to take the next step.
                      </p>
                    </span>
                  </div>
                </div>
                <div className={styles.ulelementorIconListItems2}>
                  <div
                    className={styles.aiSupportedContents}
                  >{`CRM & Sales Automations`}</div>
                  <div className={styles.attributionAnalytics}>
                    Attribution analytics
                  </div>
                </div>
              </div>
              <div className={styles.divelementorWidgetWrap}>
                <div className={styles.pseudo3} />
                <b className={styles.grow}>Grow</b>
                <div className={styles.p}>
                  <div className={styles.delightEachCustomerContainer}>
                    <p className={styles.empowerYourBusiness}>
                      Delight each customer by
                    </p>
                    <p className={styles.empowerYourBusiness}>
                      add-on marketing services
                    </p>
                  </div>
                </div>
                <div className={styles.ulelementorIconListItems3}>
                  <div className={styles.aiSeeding}>AI seeding</div>
                  <div className={styles.leadScoring}>Lead Scoring</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.body2}>
        <div className={styles.content3Wrapper}>
          <div className={styles.content3}>
            <div className={styles.divelementorFlipBoxLayer}>
              <div className={styles.div}></div>
              <div className={styles.divelementorFlipBoxLayer1}>
                <img className={styles.svgIcon} alt="" src="/svg12.svg" />
                <div className={styles.h3elementorFlipBoxLayer}>
                  <div className={styles.freeHelpCoursesContainer}>
                    <p className={styles.empowerYourBusiness}>
                      Free help courses
                    </p>
                    <p className={styles.empowerYourBusiness}>and support</p>
                  </div>
                </div>
                <div className={styles.getStarted}>Get started</div>
              </div>
            </div>
            <div className={styles.divelementorFlipBoxLayer2}>
              <div className={styles.div1}></div>
              <div className={styles.divelementorFlipBoxLayer1}>
                <img className={styles.svgIcon} alt="" src="/svg13.svg" />
                <div className={styles.h3elementorFlipBoxLayer1}>
                  <div className={styles.freeHelpCoursesContainer}>
                    <p className={styles.empowerYourBusiness}>
                      Advanced marketing
                    </p>
                    <p className={styles.empowerYourBusiness}>
                      and sales reporting
                    </p>
                  </div>
                </div>
                <div className={styles.getStarted}>Check results</div>
              </div>
            </div>
            <div className={styles.divelementorFlipBoxLayer4}>
              <div className={styles.div2}></div>
              <div className={styles.divelementorFlipBoxLayer1}>
                <img className={styles.svgIcon} alt="" src="/svg21.svg" />
                <div className={styles.h3elementorFlipBoxLayer2}>
                  <div className={styles.freeHelpCoursesContainer}>
                    <p className={styles.empowerYourBusiness}>
                      Excellent email
                    </p>
                    <p className={styles.empowerYourBusiness}>deliverability</p>
                  </div>
                </div>
                <div className={styles.getStarted}>Send better</div>
              </div>
            </div>
            <div className={styles.divelementorFlipBoxLayer6}>
              <div className={styles.div3}></div>
              <div className={styles.divelementorFlipBoxLayer1}>
                <img className={styles.svgIcon} alt="" src="/svg31.svg" />
                <div className={styles.h3elementorFlipBoxLayer3}>
                  <div className={styles.freeHelpCoursesContainer}>
                    <p className={styles.empowerYourBusiness}>
                      Gmail and Outlook inbox
                    </p>
                    <p className={styles.empowerYourBusiness}>extensions</p>
                  </div>
                </div>
                <div className={styles.getStarted}>Manage inbox</div>
              </div>
            </div>
            <div className={styles.divelementorFlipBoxLayer8}>
              <div className={styles.div4}></div>
              <div className={styles.divelementorFlipBoxLayer1}>
                <img className={styles.svgIcon} alt="" src="/svg41.svg" />
                <div className={styles.landingPages}>Landing pages</div>
                <div className={styles.getStarted}>Start building</div>
              </div>
            </div>
            <div className={styles.divelementorFlipBoxLayer10}>
              <div className={styles.div5}></div>
              <div className={styles.divelementorFlipBoxLayer1}>
                <img className={styles.svgIcon} alt="" src="/svg51.svg" />
                <div className={styles.landingPages}>Pre-built automations</div>
                <div className={styles.getStarted}>Target contacts</div>
              </div>
            </div>
            <div className={styles.divelementorFlipBoxLayer12}>
              <div className={styles.div2}></div>
              <div className={styles.divelementorFlipBoxLayer1}>
                <img className={styles.svgIcon} alt="" src="/svg61.svg" />
                <div className={styles.h3elementorFlipBoxLayer4}>
                  <div className={styles.freeHelpCoursesContainer}>
                    <p className={styles.empowerYourBusiness}>Integrated and</p>
                    <p className={styles.empowerYourBusiness}>
                      embeddable forms
                    </p>
                  </div>
                </div>
                <div className={styles.getStarted}>Make forms</div>
              </div>
            </div>
            <div className={styles.divelementorFlipBoxLayer14}>
              <div className={styles.div7}></div>
              <div className={styles.divelementorFlipBoxLayer1}>
                <img className={styles.svgIcon} alt="" src="/svg71.svg" />
                <div className={styles.landingPages}>CRM</div>
                <div className={styles.getStarted}>Automate sales</div>
              </div>
            </div>
            <b className={styles.everythingYouNeedContainer}>
              <p className={styles.empowerYourBusiness}>
                Everything you need to make the
              </p>
              <p className={styles.empowerYourBusiness}>
                path to success shorter
              </p>
            </b>
          </div>
        </div>
      </div>
      <div className={styles.body3}>
        <div className={styles.teamUpWithYourFavoriteAppParent}>
          <b className={styles.teamUpWithContainer}>
            <span className={styles.empowerYourBusinessContainer1}>
              <p className={styles.empowerYourBusiness}>Team up with your</p>
              <p className={styles.empowerYourBusiness}>favorite apps</p>
            </span>
          </b>
          <div className={styles.with870IntegrationsContainer}>
            <span className={styles.empowerYourBusinessContainer1}>
              <p className={styles.empowerYourBusiness}>
                With 870+ integrations like Shopify,
              </p>
              <p className={styles.empowerYourBusiness}>
                WordPress, and Zapier in our app
              </p>
              <p className={styles.empowerYourBusiness}>
                marketplace, you’ll have all the marketing
              </p>
              <p className={styles.empowerYourBusiness}>
                tools you need to succeed.
              </p>
            </span>
          </div>
          <div className={styles.viewAllApps}>View all apps</div>
          <div className={styles.div8}></div>
          <img
            className={styles.appsGroup768x366pngIcon}
            alt=""
            src="/appsgroup768x366png1@2x.png"
          />
        </div>
      </div>
      <div className={styles.testimonial}>
        <div className={styles.customerSpotlightsParent}>
          <b className={styles.customerSpotlights}>Customer spotlights</b>
          <div className={styles.div9}>
            <div className={styles.child} />
            <div className={styles.div10}>
              <img
                className={styles.hipcookspngIcon}
                alt=""
                src="/hipcookspng1@2x.png"
              />
              <b className={styles.hipcooks}>Hipcooks</b>
              <div className={styles.localizingOurContentContainer}>
                <span className={styles.empowerYourBusinessContainer1}>
                  <p className={styles.empowerYourBusiness}>
                    Localizing our content keeps
                  </p>
                  <p className={styles.empowerYourBusiness}>
                    our customers engaged
                  </p>
                  <p className={styles.empowerYourBusiness}>
                    because we’re able to write
                  </p>
                  <p className={styles.empowerYourBusiness}>
                    about recipes relevant to
                  </p>
                  <p className={styles.empowerYourBusiness}>
                    trends and seasons…
                  </p>
                </span>
              </div>
              <div className={styles.seeMore}>See more</div>
              <div className={styles.div11}></div>
            </div>
          </div>
          <div className={styles.div12}>
            <div className={styles.child} />
            <div className={styles.div13}>
              <img
                className={styles.msi768x589pngIcon}
                alt=""
                src="/msi768x589png1@2x.png"
              />
              <b className={styles.museumOfScienceContainer}>
                <span className={styles.empowerYourBusinessContainer1}>
                  <p className={styles.empowerYourBusiness}>
                    Museum of Science
                  </p>
                  <p className={styles.empowerYourBusiness}>and Industry</p>
                </span>
              </b>
              <div className={styles.activecampaignLetsUsContainer}>
                <span className={styles.empowerYourBusinessContainer1}>
                  <p className={styles.empowerYourBusiness}>
                    ActiveCampaign lets us send
                  </p>
                  <p className={styles.empowerYourBusiness}>
                    email campaigns, automate
                  </p>
                  <p className={styles.empowerYourBusiness}>
                    features, and manage
                  </p>
                  <p className={styles.empowerYourBusiness}>
                    contacts by staff group.
                  </p>
                </span>
              </div>
              <div className={styles.seeMore1}>See more</div>
              <div className={styles.div14}></div>
            </div>
          </div>
          <div className={styles.div15}>
            <div className={styles.child} />
            <div className={styles.div13}>
              <img
                className={styles.msi768x589pngIcon}
                alt=""
                src="/morrowaudio768x589png1@2x.png"
              />
              <b className={styles.marrowAudio}>Marrow Audio</b>
              <div className={styles.evenThoughImContainer}>
                <span className={styles.empowerYourBusinessContainer1}>
                  <p className={styles.empowerYourBusiness}>
                    Even though I’m the CEO,
                  </p>
                  <p className={styles.empowerYourBusiness}>
                    president, and founder of
                  </p>
                  <p className={styles.empowerYourBusiness}>
                    Morrow Audio, because
                  </p>
                  <p className={styles.empowerYourBusiness}>
                    ActiveCampaign is so easy to
                  </p>
                  <p className={styles.empowerYourBusiness}>
                    use – I enjoy doing it!
                  </p>
                </span>
              </div>
              <div className={styles.seeMore1}>See more</div>
              <div className={styles.div14}></div>
            </div>
          </div>
          <div className={styles.div18}>
            <div className={styles.child} />
            <div className={styles.div10}>
              <img
                className={styles.beefy768x589pngIcon}
                alt=""
                src="/beefy768x589png1@2x.png"
              />
              <b className={styles.beefyMarketing}>Beefy Marketing</b>
              <div className={styles.activecampaignHadTheContainer}>
                <span className={styles.empowerYourBusinessContainer1}>
                  <p className={styles.empowerYourBusiness}>
                    ActiveCampaign had the best
                  </p>
                  <p className={styles.empowerYourBusiness}>
                    automation features that I
                  </p>
                  <p className={styles.empowerYourBusiness}>
                    had seen, and it was highly
                  </p>
                  <p className={styles.empowerYourBusiness}>
                    intuitive… A real perfect mix of
                  </p>
                  <p className={styles.empowerYourBusiness}>
                    human and technology.
                  </p>
                </span>
              </div>
              <div className={styles.seeMore}>See more</div>
              <div className={styles.div11}></div>
            </div>
          </div>
          <div className={styles.seemore}>
            <div className={styles.seeAllCustomer}>
              See all customer case studies
            </div>
            <div className={styles.div21}></div>
          </div>
        </div>
      </div>
      <div className={styles.body4}>
        <div className={styles.frameParent4}>
          <div className={styles.tryItNowForFreeParent}>
            <div className={styles.tryItNow}>Try it now, for free</div>
            <div className={styles.noCreditCard}>
              No credit card required. Instant setup.
            </div>
          </div>
          <div className={styles.inputacInputParent}>
            <div className={styles.inputacInput}>
              <div className={styles.divplaceholder}>
                <div className={styles.emailAddress}>Email Address</div>
              </div>
            </div>
            <div className={styles.buttonactButton2}>
              <div className={styles.startYourFree}>Start your free trial</div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.testimonial1}>
        <div className={styles.divelementorWidgetWrap4}>
          <b className={styles.ourCustomersLove}>Our customers love us</b>
          <img
            className={styles.divelementorContainerIcon}
            alt=""
            src="/divelementorcontainer.svg"
          />
          <div className={styles.dontJustTakeContainer}>
            <span className={styles.empowerYourBusinessContainer1}>
              <p className={styles.empowerYourBusiness}>
                Don’t just take our word for it: 10,000+ people rank
                ActiveCampaign as an
              </p>
              <p className={styles.empowerYourBusiness}>
                industry leader across G2, Capterra, TrustRadius,
                and TrustPilot.
              </p>
            </span>
          </div>
          <div className={styles.a}>
            <div className={styles.seeReviews}>See reviews</div>
            <div className={styles.div22}></div>
          </div>
        </div>
      </div>
      <div className={styles.footer}>
        <div className={styles.touachpoint}>
          <div className={styles.divelementorContainer}>
            <div className={styles.h4elementorHeadingTitle}>
              <b className={styles.supportingYouAtContainer}>
                <p className={styles.empowerYourBusiness}>Supporting you at</p>
                <p className={styles.empowerYourBusiness}>every customer</p>
                <p className={styles.empowerYourBusiness}>touchpoint</p>
              </b>
            </div>
            <div className={styles.divelementorWidgetWrap5}>
              <b className={styles.reach1}>Reach</b>
              <div className={styles.ulelementorIconListItems4}>
                <div className={styles.emailTemplates}>Email Templates</div>
                <div className={styles.emailNewsletter}>Email Newsletter</div>
                <div className={styles.createForms}>Create Forms</div>
                <div className={styles.popUpBuilder}>Pop Up Builder</div>
                <div className={styles.leadGeneration}>Lead Generation</div>
              </div>
            </div>
            <div className={styles.divelementorWidgetWrap5}>
              <b className={styles.nurture1}>Nurture</b>
              <div className={styles.ulelementorIconListItems4}>
                <div className={styles.conversationalMarketing}>
                  Conversational Marketing
                </div>
                <div className={styles.facebookAdvertising}>
                  Facebook Advertising
                </div>
                <div className={styles.socialMediaAdvertising}>
                  Social Media Advertising
                </div>
                <div className={styles.leadTrackingSoftware}>
                  Lead Tracking Software
                </div>
                <div className={styles.a1}>
                  <div className={styles.wordpress}>Wordpress</div>
                  <img className={styles.svgIcon8} alt="" src="/svg8.svg" />
                </div>
              </div>
            </div>
            <div className={styles.divelementorWidgetWrap5}>
              <b className={styles.convertGrow}>{`Convert & Grow`}</b>
              <div className={styles.ulelementorIconListItems4}>
                <div className={styles.salesPlatform}>Sales Platform</div>
                <div className={styles.salesAnalytics}>Sales Analytics</div>
                <div className={styles.leadScoring1}>Lead Scoring</div>
                <div className={styles.attributionSoftware}>
                  Attribution Software
                </div>
                <div className={styles.a1}>
                  <div className={styles.salesforce}>Salesforce</div>
                  <img className={styles.svgIcon8} alt="" src="/svg9.svg" />
                </div>
              </div>
            </div>
            <div className={styles.divelementorWidgetWrap5}>
              <b className={styles.ecommerce}>ECommerce</b>
              <div className={styles.ulelementorIconListItems4}>
                <div className={styles.ecommerceMarketing}>
                  Ecommerce Marketing
                </div>
                <div className={styles.ecommercePersonalization}>
                  Ecommerce Personalization
                </div>
                <div className={styles.shoppingCartAbandonment}>
                  Shopping Cart Abandonment
                </div>
                <div className={styles.a3}>
                  <div className={styles.shopify}>Shopify</div>
                  <img className={styles.svgIcon8} alt="" src="/svg10.svg" />
                </div>
                <div className={styles.a1}>
                  <div className={styles.woocommerce}>WooCommerce</div>
                  <img className={styles.svgIcon8} alt="" src="/svg11.svg" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.detailedCate}>
          <div className={styles.divelementorContainer1}>
            <div className={styles.divelementorWidgetWrap9}>
              <div className={styles.a5}>
                <b className={styles.customerExperienceAutomationContainer}>
                  <p className={styles.empowerYourBusiness}>
                    Customer Experience
                  </p>
                  <p className={styles.empowerYourBusiness}>Automation</p>
                </b>
              </div>
              <div className={styles.ulelementorIconListItems4}>
                <div className={styles.emailMarketingAutomation}>
                  Email Marketing Automation
                </div>
                <div className={styles.marketingAutomation}>
                  Marketing Automation
                </div>
                <div className={styles.salesAutomation}>Sales Automation</div>
                <div className={styles.salesEngagement}>Sales Engagement</div>
                <div
                  className={styles.serviceSupport}
                >{`Service & Support`}</div>
              </div>
            </div>
            <div className={styles.divelementorWidgetWrap9}>
              <div className={styles.a5}>
                <b className={styles.customerExperienceAutomationContainer}>
                  <p className={styles.empowerYourBusiness}>Omni-channel</p>
                  <p className={styles.empowerYourBusiness}>Marketing</p>
                </b>
              </div>
              <div className={styles.ulelementorIconListItems9}>
                <div className={styles.landingPages1}>Landing Pages</div>
                <div className={styles.liveChat}>Live Chat</div>
                <div className={styles.smsMarketing}>SMS Marketing</div>
                <div className={styles.socialMediaMarketing}>
                  Social Media Marketing
                </div>
                <div className={styles.webPersonalization}>
                  Web Personalization
                </div>
                <div className={styles.transactionalEmail}>
                  Transactional Email
                </div>
              </div>
            </div>
            <div className={styles.divelementorWidgetWrap9}>
              <div className={styles.a7}>
                <b className={styles.customerExperienceAutomationContainer}>
                  <p
                    className={styles.empowerYourBusiness}
                  >{`Getting Started &`}</p>
                  <p className={styles.empowerYourBusiness}>Resources</p>
                </b>
              </div>
              <div className={styles.ulelementorIconListItems10}>
                <div className={styles.getStarted1}>Get Started</div>
                <div className={styles.liveExpertWorkshop}>
                  Live Expert Workshop
                </div>
                <div className={styles.strategySession}>
                  1:1 Strategy Session
                </div>
                <div className={styles.community}>Community</div>
                <div className={styles.events}>Events</div>
                <div className={styles.helpResources}>Help Resources</div>
                <div className={styles.productUpdates}>Product Updates</div>
                <div className={styles.marketingGlossary}>
                  Marketing Glossary
                </div>
                <div className={styles.blog}>Blog</div>
              </div>
            </div>
            <div className={styles.divelementorWidgetWrap12}>
              <div className={styles.divelementorWidgetWrap9}>
                <div className={styles.a8}>
                  <b className={styles.customerExperienceAutomationContainer}>
                    <p className={styles.empowerYourBusiness}>{`Apps &`}</p>
                    <p className={styles.empowerYourBusiness}>Integrations</p>
                  </b>
                </div>
                <div className={styles.ulelementorIconListItems11}>
                  <div className={styles.integrationMarketplace}>
                    Integration Marketplace
                  </div>
                  <div className={styles.developerCenter}>Developer Center</div>
                  <div className={styles.freeTools}>Free Tools</div>
                  <div className={styles.automationRecipes}>
                    Automation Recipes
                  </div>
                </div>
              </div>
              <div className={styles.divelementorWidgetWrap5}>
                <b className={styles.becomeAPartner}>Become a Partner</b>
                <div className={styles.ulelementorIconListItems12}>
                  <div
                    className={styles.agencyReseller}
                  >{`Agency & Reseller`}</div>
                  <div className={styles.affiliate}>Affiliate</div>
                  <div className={styles.isvDeveloper}>{`ISV & Developer`}</div>
                </div>
              </div>
            </div>
            <div className={styles.divelementorWidgetWrap15}>
              <div className={styles.divelementorWidgetWrap9}>
                <div className={styles.a5}>
                  <b className={styles.customerExperienceAutomationContainer}>
                    <p className={styles.empowerYourBusiness}>About</p>
                    <p className={styles.empowerYourBusiness}>ActiveCampaign</p>
                  </b>
                </div>
                <div className={styles.ulelementorIconListItems9}>
                  <div className={styles.whyActivecampaign}>
                    Why ActiveCampaign
                  </div>
                  <div className={styles.howWeCompare}>How We Compare</div>
                  <div className={styles.customerStories}>Customer Stories</div>
                  <div className={styles.careers}>Careers</div>
                  <div className={styles.faq}>FAQ</div>
                  <div className={styles.newsroom}>Newsroom</div>
                </div>
              </div>
              <div className={styles.divelementorWidgetWrap5}>
                <b className={styles.learnMore}>Learn more</b>
                <div className={styles.ulelementorIconListItems11}>
                  <div className={styles.contactUs}>Contact Us</div>
                  <div className={styles.requestADemo}>Request a Demo</div>
                  <div className={styles.freeTrial}>Free Trial</div>
                  <div className={styles.pricing2}>Pricing</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.language}>
          <div className={styles.sectionelementorSection1}>
            <div className={styles.ul}>
              <div className={styles.spanwpmlLsNative}>
                <div className={styles.english1}>English</div>
              </div>
              <div className={styles.liwpmlLsSlotFooter}>
                <div className={styles.div23}>{`. `}</div>
                <div className={styles.espaol}>Español</div>
              </div>
              <div className={styles.liwpmlLsSlotFooter1}>
                <div className={styles.div23}>{`. `}</div>
                <div className={styles.franais}>Français</div>
              </div>
              <div className={styles.liwpmlLsSlotFooter2}>
                <div className={styles.div23}>{`. `}</div>
                <div className={styles.espaol}>Italiano</div>
              </div>
              <div className={styles.liwpmlLsSlotFooter3}>
                <div className={styles.div23}>{`. `}</div>
                <div className={styles.deutsch}>Deutsch</div>
              </div>
              <div className={styles.liwpmlLsSlotFooter4}>
                <div className={styles.div23}>{`. `}</div>
                <div className={styles.franais}>Português</div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.social}>
          <div className={styles.divelementorContainer2}>
            <div className={styles.divelementorWidgetWrap18}>
              <div className={styles.divelementorWidgetContainer}>
                <div className={styles.ulelementorIconListItems15}>
                  <div className={styles.div28}></div>
                  <div className={styles.div29}></div>
                  <div className={styles.div30}></div>
                  <div className={styles.div31}></div>
                </div>
              </div>
              <div className={styles.divelementorWidgetContainer1}>
                <div className={styles.ulelementorIconListItems16}>
                  <div className={styles.div32}></div>
                  <div className={styles.div32}></div>
                </div>
              </div>
              <div className={styles.divelementorElement}>
                <img
                  className={styles.blueSeal20042Bbb88495326Icon}
                  alt=""
                  src="/blueseal20042bbb88495326png1@2x.png"
                />
              </div>
              <div className={styles.divlegalCenter}>
                <div className={styles.divelementorWidgetContainer2}>
                  <div className={styles.legalCenter}>Legal Center</div>
                </div>
              </div>
              <div className={styles.divelementorWidgetContainer3}>
                <div className={styles.legalCenter}>Privacy Policy</div>
              </div>
            </div>
            <div className={styles.formactSearchForm}>
              <div className={styles.divactSearchContainer}>
                <div className={styles.div34}></div>
                <div className={styles.divplaceholder1}>
                  <div className={styles.search}>Search</div>
                </div>
              </div>
              <div className={styles.buttonactSearchSubmit}>
                <div className={styles.supportingYouAtContainer}>Search</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImFucked;
